import styled from 'styled-components';
import { transitionCssMixin } from '../../../mixins/custom';
export const StyledLink = styled.a.withConfig({
  componentId: "styled__sc-11n2pme-0"
})(["text-decoration:none;", ";", " color:", ";:hover{color:", ";}:active{color:", ";}"], transitionCssMixin('color'), ({
  isCursorPointer
}) => isCursorPointer && 'cursor: pointer;', ({
  themeBg,
  skin,
  theme,
  linkType
}) => themeBg && skin && theme[linkType][themeBg][skin].default, ({
  themeBg,
  skin,
  theme,
  linkType
}) => themeBg && skin && theme[linkType][themeBg][skin].hover, ({
  themeBg,
  skin,
  theme,
  linkType
}) => themeBg && skin && theme[linkType][themeBg][skin].active);